import React from "react";
import QuestionPaginationItemContainer from "./QuestionPaginationItemContainer";
import { spacing } from "../library/theme";

const container = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "wrap",
  maxWidth: "100%",
  marginTop: spacing.s,
};

const buildEntryKey = (item) => {
  if (item.stem?.id) return `stem-${item.stem.id}`;
  if (item.isFlow) return `flow-${item.question.id}`;
  return `q-${item.question.id}`;
};

export default function QuestionPagination({ flattenedQuestions }) {
  return flattenedQuestions?.length ? (
    <div style={container}>
      {flattenedQuestions.map((item, index) => (
        <QuestionPaginationItemContainer
          key={`${item.question.id}-${buildEntryKey(item)}`}
          index={index}
          question={item.question}
          stem={item.stem}
          isFlow={!!item.isFlow}
          displayIndex={item.displayIndex}
        />
      ))}
    </div>
  ) : null;
}
